import { Job, CreateJobData } from '../types/job';
import { API_BASE } from './config';
import apiClient from './client';

const API_BASE_URL = `${API_BASE}/api/Job`;

export async function getJobs(filters?: { categoryId?: number; categoryIds?: number[]; location?: string }): Promise<Job[]> {
  const params = new URLSearchParams();
  if (filters?.categoryIds?.length) {
    filters.categoryIds.forEach(id => params.append('categoryIds', id.toString()));
  } else if (filters?.categoryId) {
    params.append('categoryIds', filters.categoryId.toString());
  }
  if (filters?.location) params.append('location', filters.location);
  const response = await fetch(`${API_BASE_URL}?${params.toString()}`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
}

export async function getCompletedJobsForContractor(contractorProfileId: number): Promise<Job[]> {
  const response = await fetch(`${API_BASE_URL}/contractor/${contractorProfileId}/completed`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
}

export async function getMyJobs(): Promise<Job[]> {
  const response = await apiClient.get<Job[]>('/Job/my');
  return response.data;
}

export async function getAppliedJobs(): Promise<Job[]> {
  const response = await apiClient.get<Job[]>('/Job/applied');
  return response.data;
}

export async function getJobById(id: number): Promise<Job> {
  const response = await fetch(`${API_BASE_URL}/${id}`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
}

export async function createJob(data: CreateJobData): Promise<Job> {
  const response = await apiClient.post<Job>('/Job', data);
  return response.data;
}

export async function cancelJob(jobId: number): Promise<Job> {
  const response = await apiClient.put<Job>(`/Job/${jobId}/cancel`, {});
  return response.data;
}

export async function markJobIncomplete(jobId: number): Promise<Job> {
  const response = await apiClient.put<Job>(`/Job/${jobId}/incomplete`, {});
  return response.data;
}

export async function confirmJobCompletion(jobId: number): Promise<Job> {
  const response = await apiClient.put<Job>(`/Job/${jobId}/confirm`, {});
  return response.data;
}

export async function getModerationQueue(): Promise<Job[]> {
  const response = await apiClient.get<Job[]>('/Job/moderation-queue');
  return response.data;
}

export async function approveJob(jobId: number): Promise<Job> {
  const response = await apiClient.put<Job>(`/Job/${jobId}/approve`, {});
  return response.data;
}

export async function deleteJob(jobId: number): Promise<void> {
  await apiClient.delete(`/Job/${jobId}`);
}

export async function uploadJobPicture(file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  const response = await apiClient.post<{ url: string }>('/Upload', form);
  return response.data.url;
}
